// extracted by mini-css-extract-plugin
export default {"arrows":"SwipeArrows_arrows__6brod","arrow-right":"SwipeArrows_arrow-right__eW6WF","blink":"SwipeArrows_blink__vam2Y","arrow-left":"SwipeArrows_arrow-left__W5y53"};